export default "__VITE_ASSET__$260ed15__"